import React, { ReactNode, useCallback, useState } from "react";
import { Button, Col, CustomInput, Row, Spinner } from "reactstrap";

import { Actions, LoggedInState } from "../../../types";

type Props = Readonly<{
  actions: Actions;
  auth: LoggedInState;
  customSettings: ReactNode | null;
}>;

export const Settings = ({ actions, auth: { activeKey, user }, customSettings }: Props) => {
  const [loggingOut, setLoggingOut] = useState(false);
  let logoutContents = <>Logout</>;
  if (loggingOut) {
    logoutContents = (
      <>
        Logout
        <Spinner className="ml-2" size="sm" />
      </>
    );
  }
  const onLogoutClick = useCallback(() => {
    if (!window.confirm("Are you sure you want to logout?")) {
      return;
    }
    setLoggingOut(true);
    setTimeout(actions.logout, 1000);
  }, [actions.logout]);
  return (
    <div>
      {customSettings && (
        <>
          {customSettings}
          <hr />
        </>
      )}
      <Row>
        <Col>
          <strong>Live Key</strong>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col xs={8}>Use live key?</Col>
        <Col className="text-right" xs={4}>
          <CustomInput
            bsSize="lg"
            checked={activeKey === "live"}
            id="toggleLiveKey"
            onChange={() => {
              actions.toggleActiveKey();
            }}
            type="switch"
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-muted">
          While using the live key, workbench data will be used to train and improved the predictive
          models.
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <strong>Account Details</strong>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col xs={8}>
          <Row>
            <Col xs={3}>Name</Col>
            <Col className="text-truncate" title={user.name} xs={9}>
              {user.name}
            </Col>
          </Row>
          <Row>
            <Col xs={3}>Email</Col>
            <Col className="text-truncate" title={user.email} xs={9}>
              {user.email}
            </Col>
          </Row>
        </Col>
        <Col className="text-right" xs={4}>
          <Button
            color="secondary"
            disabled={loggingOut}
            onClick={onLogoutClick}
            size="sm"
            type="button"
          >
            {logoutContents}
          </Button>
        </Col>
      </Row>
    </div>
  );
};
Settings.displayName = "Settings";
